import { FormGridField } from "../../components/FormGrid";

export interface HiddenInputDefinition {
    name: string;
    id: string;
    placeholder: string;
    label: string;
    schemaName: string;
    fieldOverrides?: any;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildHiddenInputDefinition({
    name,
    id,
    placeholder,
    label,
    schemaName,
    fieldOverrides
}: {
    name: string;
    id: string;
    placeholder: string;
    label: string;
    schemaName: string;
    fieldOverrides?: any;
}): HiddenInputDefinition {
    return {
        name,
        id,
        placeholder,
        label,
        schemaName,
        fieldOverrides,
        buildFormGridField: _createHiddenInputField
    };
}

function _createHiddenInputField(schema): FormGridField {
    const { name, id, label, placeholder, schemaName, fieldOverrides } = this;

    return {
        name,
        fieldType: "input",
        fieldOptions: {
            id,
            placeholder,
            inputType: "hidden",
            label
        },
        validationSchema: {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        },
        columnClass: "hidden",
        formSpacing: true,
        ...fieldOverrides
    };
}
